<template>
  <v-dialog v-model="modelStores" width="640px" v-on:update:modelValue="fechar" :persistent="getConfig.store > 0 ? false: true">
    <v-btn v-if="getConfig.store > 0" icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card>
      <v-card-text class="pa-0">
        <v-row class="position-relative ma-0">
          <v-col class="d-none d-lg-block v-col-6 py-0 ps-0 pe-6">
            <img src="@/assets/images/modal-escolher-loja.jpg" class="img-dialog">
          </v-col>
          <v-col class="v-col-12 v-col-lg-6 d-flex align-between flex-wrap pe-6 py-6 ps-6 ps-lg-0">
            <div class="w-100">
              <span data-cy="welcome" class="text-color-black text-xhuge text-fine">SEJA<br>BEM-VINDO</span>
              <v-form ref="store" lazy-validation class="mt-6">
                <div class="w-100" v-if="isCep">
                  <v-text-field variant="outlined" :hide-details="true" label="Informe seu CEP"></v-text-field>
                </div>
                <div class="w-100" v-else>
                  <v-select ref="city_active" :rules="[rules.required]" v-if="getCities.length > 0" v-model="city" :items="getCities" item-title="city" item-value="city" label="SELECIONE A CIDADE" data-cy="option-city" class="text-uppercase">
                    <template v-slot:item="data">
                      <v-list-item @click="selectCity(data.item.raw.city)">
                        <template v-slot:prepend>
                          <Svgs :icon="'pin'" :color="'fill-color-2'" :width="20" :height="20"></Svgs>
                        </template>
                        <v-list-item-title class="link-menu ms-3 text-uppercase">{{ data.item.raw.city }}</v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-select>
                </div>
                <div class="w-100" v-if="city != null">
                  <v-select ref="store_active" :rules="[rules.required]" v-if="getStores.length > 0" v-model="store" :items="getStores" item-title="name" item-value="id" class="mt-4 text-uppercase" label="SELECIONE UMA DE NOSSAS UNIDADES" data-cy="option-store">
                    <template v-slot:item="data">
                      <v-list-item @click="selectStore(data.item.value)">
                        <template v-slot:prepend>
                          <Svgs :icon="'market'" :color="'fill-color-2'" :width="20" :height="20"></Svgs>
                        </template>
                        <v-list-item-title class="link-menu ms-3 text-uppercase">{{ data.item.raw.name }}</v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-select>
                </div>
              </v-form>
            </div>
            <div class="w-100 d-flex align-end mt-5">
              <v-btn variant="flat" block size="x-large" :loading="loading" :disabled="store== null" class="bg-color-2 text-color-white cy-dialogstore-confirm" @click="confirmar()">CONFIRMAR</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Svgs from '@/components/Svgs.vue';
export default {
  name: 'DialogStores',
  data(){
    return {
      loading: false,
      city: null,
      store: null,
      modelStores: false,
      rules: {
        required: v => !!v || 'Este campo é obrigatório.',
      },
    }
  },
  components: {
    Svgs
  },
  props: {
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  computed: {
    ...mapState('main', {
      isCep: 'isCep'
    }),
    ...mapGetters('main', {
      getCities: 'getCities',
      getStores: 'getStores',
      getConfig: 'getConfig'
    }),
  },
  watch: {
    model() {
      this.modelStores = this.model;
      if(this.model == true){
        this.loadCities();
        this.city = null;
        this.store = null;
      }
    },
    city(){
      this.store = null;
      this.loadStores(this.city);
    }
  },
  methods: {
    ...mapActions('main', {
      loadCities: 'loadCities',
      loadStores: 'loadStores',
      changeStore: 'changeStore',
      setConfig: 'setConfig',
      getBanners: 'getBanners',
      getFixedBanners: 'getFixedBanners'
    }),
    async confirmar(){
      const { valid } = await this.$refs.store.validate();
      if (valid){
        this.loading = true;
        this.changeStore(this.store).then(function(){
          this.setConfig().then(function(response){
            if(response == true){
              this.loading = false;
              this.fechar();
              if(this.$route.name == "Home"){
                this.getBanners();
                this.getFixedBanners();
              } else {
                this.$router.push('/');
              }
            } else {
              this.changeStore(0).then(function(){
                this.loading = false;
                this.city = null;
                this.store = null;
              }.bind(this));
            }
          }.bind(this));
        }.bind(this));
      }
    },
    selectCity(city){
      this.city = city;
      this.$refs.city_active.blur();
    },
    selectStore(store){
      this.store = store;
      this.$refs.store_active.blur();
    },
  }
}
</script>